var _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _path5, _circle5, _path6, _circle6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle62D = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M6.001 26.5a2.5 2.5 0 0 1 2.5-2.5h43a2.5 2.5 0 0 1 2.5 2.5v7a2.5 2.5 0 0 1-2.5 2.5h-43a2.5 2.5 0 0 1-2.5-2.5v-7Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 45.992,
  cy: 45,
  r: 6,
  fill: "#464D57",
  transform: "rotate(-180 45.992 45)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M50.234 49.243a6 6 0 0 1-8.485 0"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.008,
  cy: 15,
  r: 6,
  fill: "#464D57"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M9.766 10.757a6 6 0 0 1 8.485 0"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.991,
  cy: 45,
  r: 6,
  fill: "#464D57",
  transform: "rotate(-180 29.991 45)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M34.234 49.243a6 6 0 0 1-8.485 0"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 30.009,
  cy: 15,
  r: 6,
  fill: "#464D57"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M25.766 10.757a6 6 0 0 1 8.485 0"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.992,
  cy: 45,
  r: 6,
  fill: "#464D57",
  transform: "rotate(-180 13.992 45)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M18.234 49.243a6 6 0 0 1-8.485 0"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 46.008,
  cy: 15,
  r: 6,
  fill: "#464D57"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M41.766 10.757a6 6 0 0 1 8.485 0"
})));
SvgRectangle62D.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle62D);
export default ForwardRef;